export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_ja.a229dfa02de2c0c2.json"